import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useApi } from "../../utils/Api";
import "./stylesheet.css";
import Translate from "../../utils/Translate";
import Preloader from "../Preloader";
import { ShoppingCart } from "@mui/icons-material";
import {
  pseudoELearningTypes,
  multiELearningTypes,
  pseudoELearningTypeEnum,
  multiELearningTypeEnum,
} from "../../utils/eLearningTypes";
import { Stack, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export function Balance({ switchMode }) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    recalculate();
  }, []);

  function recalculate() {
    api
      .fetch(
        `${import.meta.env.VITE_MAIN_URL}licenses/elearning/count/allELearningTypesBalance?includeMulti=true`,
        false,
        "GET"
      )
      .then((data) => {
        if (!data.error) {
          setData(data);
        }
      })
      .finally((f) => {
        setIsLoading(false);
      });
  }

  function getTooltipText(eLearningType) {
    switch (eLearningType) {
      case pseudoELearningTypeEnum.ExtraFinalExam:
        return Translate.get("ExtraFinalExamExplanation");
      case multiELearningTypeEnum.MultiELiftAndEFall:
        return Translate.get("MultiELearningExplanation");
      default:
        return null;
    }
  }

  const cards = data.map((item, i) => {
    const isPseudo = item.eLearningType in pseudoELearningTypes;
    const isMulti = item.eLearningType in multiELearningTypes;
    return (
      <div
        className="stdCard"
        key={i}
        style={{
          maxWidth: "400px",
          backgroundColor: isMulti ? "rgba(0, 110, 200, 0.08)" : null,
        }}
      >
        <div className="stdCardHeader">
          <Stack direction="row" justifyContent="space-between">
            <div>{`${Translate.getELearningType(item.eLearningType)}${
              item.extraLabel ? ` (${item.extraLabel})` : ""
            }`}</div>
            {!!getTooltipText(item.eLearningType) && (
              <Tooltip title={getTooltipText(item.eLearningType)}>
                <InfoIcon color="primary" />
              </Tooltip>
            )}
          </Stack>
        </div>

        <div className="stdCardBody">
          <div className={"stdCardInnerBox" + (isMulti ? " visibilityHidden" : "")}>
            {Translate.get("Balance") + ": " + item.numberOfFreeLicenses}
          </div>
        </div>

        <div className="stdCardFooter">
          {/* Removed feature for extra final exams for now since it's not implemented backend.
              But it should be pretty easy to implement it using the existing logic in ePortWebLibrary
              ELearningLicenseDbService.ELearningLicense_UndoAddExtraFinalExamAsync */}
          {!isPseudo && !isMulti && (
            <Button
              name="recall"
              value={item.eLearningType}
              onClick={() => switchMode("recall", item.eLearningType, item.eLearningCode)}
              variant="text"
            >
              {Translate.get("RecallUnused")}
            </Button>
          )}
          <Button
            name="order"
            value={item.eLearningType}
            onClick={() => switchMode("order", item.eLearningType, item.eLearningCode)}
            variant="contained"
            endIcon={<ShoppingCart />}
          >
            {Translate.get("PlaceOrder")}
          </Button>
        </div>
      </div>
    );
  });

  return (
    <div className="stdPage">
      <div className="stdPageTitle">{Translate.get("ElearningPassword")}</div>
      {isLoading && <Preloader />}

      <div className="stdCardHolder">{cards}</div>
    </div>
  );
}
